document.addEventListener("DOMContentLoaded", function (event) {
  let urlLabels = document.querySelectorAll('.product-selector__buttons label[data-url]');
  urlLabels.length && urlLabels.forEach((item) => {
    item.addEventListener('click', (e) => {
      document.location.href = item.dataset.url;
    })
  })
});

document.addEventListener("DOMContentLoaded", function (event) {
  let heroImageBg = document.querySelectorAll('.hero__image-background[data-url]');
  heroImageBg.length && heroImageBg.forEach((item) => {
    item.addEventListener('click', (e) => {
      document.location.href = item.dataset.url;
    })
  })
});

document.addEventListener("DOMContentLoaded", function (event) {
  if(document.querySelector('.product__content ')) {
    document.querySelectorAll('.shipping-info__list li').forEach((el, index) => {
      el.addEventListener('click', () => {
        document.querySelector('.shipping-info__popup').style.display = "block";
        let position = index % 3;
        document.querySelectorAll('.shipping-info__popup-content-title > span')[position].classList.add('active');
        document.querySelectorAll('.shipping-info__popup-des > div')[position].classList.add('active');
      });
    });
    document.querySelector('.shipping-info__popup-close').addEventListener('click', () => {
      document.querySelector('.shipping-info__popup').style.display = "none";
      document.querySelectorAll('.shipping-info__popup-content-title > span, .shipping-info__popup-des > div').forEach((el) => {
        el.classList.remove('active');
      });
    });
    document.querySelectorAll('.shipping-info__popup-content-title > span').forEach((el, index) => {
      el.addEventListener('click', () => {
        document.querySelectorAll('.shipping-info__popup-content-title > span, .shipping-info__popup-des > div').forEach((el) => {
          el.classList.remove('active');
        });
        el.classList.add('active');
        document.querySelectorAll('.shipping-info__popup-des > div')[index].classList.add('active');
      });
    })
  }
});

function toggleProductBottomButton() {
  let productBottomButton = document.querySelector('.product-bottom-button');
  const triggerHeight = 1100;

  if(window.scrollY > triggerHeight) {
    productBottomButton.style.display = 'flex';
  } else {
    productBottomButton.style.display = 'none';
  }
}
document.addEventListener("DOMContentLoaded", function (event) {
  document.querySelector('.product__content ') && window.addEventListener('scroll', toggleProductBottomButton);
});
document.addEventListener("DOMContentLoaded", function (event) {
  let slides = document.querySelectorAll('.hero-slider__desktop .swiper-slide');
  let wapSlideWrapper = document.querySelectorAll('.hero-slider__mobile .swiper-slide');
  slides && Array.prototype.forEach.call(slides, (item) => {
    item.addEventListener('click', function() {
      let index = parseInt(this.dataset.id) + 1;
      gtag("event", "pc_slider_click", {
        "event_category": "pc_slider",
        "event_label": "slider" + index
      });
    });
  });
  wapSlideWrapper && Array.prototype.forEach.call(wapSlideWrapper, (item) => {
    item.addEventListener('click', function() {
      let index = parseInt(this.dataset.id) + 1;
      gtag("event", "m_slider_click", {
        "event_category": "m_slider",
        "event_label": "slider" + index
      });
    });
  });
});
document.addEventListener("DOMContentLoaded", function (event) {
  if(Shopify.template == 'product') {
    let timerBox = document.querySelector('.activity-timer');
    if(timerBox) {
      let timerHour = document.querySelector('.activity-timer__hour');
      let timerMin = document.querySelector('.activity-timer__min');
      let timerSecond = document.querySelector('.activity-timer__second');
      let countdownInterval = setInterval(countdown, 1000);
      function countdown() {
        let now = new Date();
        let hours = 23 - now.getHours();
        let minutes = 59 - now.getMinutes();
        let seconds = 59 - now.getSeconds();
        hours < 10 && (hours = "0" + hours),
        minutes < 10 && (minutes = "0" + minutes),
        seconds < 10 && (seconds = "0" + seconds);
    
        timerHour.innerHTML = `<span>${hours}</span>`;
        timerMin.innerHTML = `<span>${minutes}</span>`;
        timerSecond.innerHTML = `<span>${seconds}</span>`;
        if (hours == 0 && minutes == 0 && seconds == 0) {
          clearInterval(countdownInterval);
          countdown();
        }
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function (event) {
  setTimeout(() => {
    let avpWaterMark = document.querySelector('.avp-watermark-footer');
    console.log(avpWaterMark)
    if(avpWaterMark) {
      avpWaterMark.remove();
    }
    let avpOptionContainer = document.querySelector('.avpoptions-container__v2');
    if(avpOptionContainer) {
      let sizeGuide = document.createElement('div');
      sizeGuide.innerHTML = 
      `
        <modal-opener data-modal="#Size-Guide-Modal" class="no-js-hidden avp-size-guide">
          <button type="button" class="product__size-guide-button" aria-haspopup="dialog">Size Chart</button>
        </modal-opener>
      `;
      console.log(sizeGuide);
      avpOptionContainer.appendChild(sizeGuide);
    }
  }, 300);
})

document.addEventListener("DOMContentLoaded", function (event) {
  let joinBtn = document.querySelector('.clickable-join');
  let loginBtn = document.querySelector('.clickable-login');

  joinBtn && joinBtn.addEventListener('click', function() {
    SmileUI.openPanel();
  });
  loginBtn && loginBtn.addEventListener('click', function() {
    window.location.href = this.dataset.link;
  });
})

document.addEventListener("DOMContentLoaded", function (event) {
  let paymentLearnMoreBtn = document.querySelector('.product__payment-learn-more');
  paymentLearnMoreBtn && paymentLearnMoreBtn.addEventListener('click', function() {
    window.location.href = '/checkout';
  });
})


document.addEventListener("DOMContentLoaded", function (event) {
  let popTrigger = document.querySelector('.product__standard-guarantee');
  let popover = document.querySelector('.popover-container');
  let popOverlay = document.querySelector('.popover__overlay');
  let popClose = document.querySelector('.popover__close-button');

  if(popTrigger && popover) {
    popTrigger.addEventListener('click', function() {
      popover.toggleAttribute('open');
    });
    popOverlay.addEventListener('click', function() {
      popover.toggleAttribute('open');
    });
    popClose.addEventListener('click', function() {
      popover.toggleAttribute('open');
    });
  }
});

document.addEventListener("DOMContentLoaded", function (event) {
  let imageSlider = document.querySelector('.section-image-slider');
  if(imageSlider) {
    let imageCarousel = new Swiper('.section-image-slider .swiper', {
      slidesPerView: 4,
      loop: false,
      preventClicks:false,
      spaceBetween: 10,
      grabCursor: true,
    })
  }
});

document.addEventListener("DOMContentLoaded", function (event) {
  let footerExpand = document.querySelectorAll('.footer .footer__nav h3');
  footerExpand.length && footerExpand.forEach((item) => {
    item.addEventListener('click', (el) => {
      item.classList.toggle('open');
    })
  })
});

let productsArea = document.querySelectorAll('.mobile-products-area .swiper');
productsArea.length && productsArea.forEach((item) => {
  let Carousel = new Swiper(item, {
    slidesPerView: 1.3,
    loop: false,
    preventClicks:false,
    spaceBetween: 20,
    grabCursor: true,
  })
});

let shopByPrintSwiper = document.querySelector('.shop-by-print__slider.swiper');
if(shopByPrintSwiper) {
  let shopByPrintSlider = new Swiper(shopByPrintSwiper, {
    slidesPerView: 1.4,
    loop: false,
    preventClicks:false,
    spaceBetween: 10,
    grabCursor: true,
    navigation: {
      prevEl: '.shop-by-print__slider-prev',
      nextEl: '.shop-by-print__slider-next'
    },
    breakpoints: {
      800: {
        slidesPerView: 4.2,
        spaceBetween: 30
      },
      1600: {
        slidesPerView: 5.2,
        spaceBetween: 30
      }
    }
  });
}



/*
document.addEventListener("DOMContentLoaded", function (event) {
  let navigation = document.querySelector('.header-navigation');
  let mobileNav = document.querySelector('.header__mobile-level-one');
  let mobileNavButton = document.querySelector('.header-mobile__button');
  let shopByCollection = document.querySelector('.section-shop-by-collection');
  if(navigation && shopByCollection) {
    navigation.addEventListener('click', (e) => {
      if(e.target.innerText == 'Shop By Style') {
        e.preventDefault();
        window.scrollTo({top: shopByCollection.offsetTop - 80, behavior: 'smooth'});
      }
    })
  }
  if(mobileNav && shopByCollection) {
    mobileNav.addEventListener('click', (e) => {
      if(e.target.innerText == 'Shop By Style') {
        e.preventDefault();
        mobileNavButton.click();
        window.scrollTo({top: shopByCollection.offsetTop - 80, behavior: 'smooth'});
      }
    })
  }
});*/

/*
document.addEventListener("DOMContentLoaded", function (event) {
  let recommendationMore = document.querySelector('product-recommendations .button');
  if(recommendationMore && Shopify.template == 'product') {
    let recommendationEle = document.querySelector('product-recommendations');
    let limit = 4;
    let url = '/recommendations/products?section_id=' + recommendationEle.parentElement.id + '&product_id=' + current_productid + '&limit=' + limit;
    console.log(url);
  }
});
*/